<template>
  <div class="container-form-login-google" v-if="!currentUser || !currentUser.id">
    <google-button-v2 type="login">
      Log in with Google
    </google-button-v2>

    <div class="separator my-6" v-if="settingShowSeparator" :class="{'dark': textColour === '#ffffff'}">
      &nbsp;OR&nbsp;
    </div>
  </div>
</template>

<script>
import GoogleButtonV2 from '@/components/common/GoogleButtonV2.vue'
import { mapState } from 'vuex'
import config from '@/config'
import constant from '@/constant'

export default {
  name: 'ContainerLoginGoogle',
  components: { GoogleButtonV2 },
  props: {
    showSeparator: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      showButtonLogin: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      textColour: (state) => state.slide.textColour,
    }),
    isWhiteLabelUser() {
      return window.location.host !== config.domain
    },
    settingShowSeparator() {
      if (!this.showSeparator) {
        return false
      }
      if (this.isWhiteLabelUser) {
        return false
      }
      if (config.region === constant.euRegion) {
        return false
      }
      return this.$route.query.fromIframe !== 'true'
    },
  },
}
</script>

<style scoped>

.separator {
  --tw-text-opacity: 1;
  color: rgba(75, 75, 75, var(--tw-text-opacity));
  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1rem;

  &.dark {
    color: rgba(255, 255, 255, 1);
    &::before, &::after{
      border-color: rgb(104,104,104);
    }
  }
}

.separator::before, .separator::after {
    content: "";
    flex: 1;
}

.separator::before, .separator::after {
    border-bottom-width: 0;
    --tw-border-opacity: 1;
    border-color: rgba(235, 235, 235, var(--tw-border-opacity));
    border-style: solid;
}

.separator::before{
  margin-right: 12px;
}

.separator::after{
  margin-left: 12px;
}
</style>
